import { faMobileButton } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import { menusSlice } from '»components/Menus/_menus.slice';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
} from '»components/Menus/menus.selectors';
import {
  FontAwesomeIconMobileStyled,
  ListItemIconMobileStyled,
  RootListItemButtonMobileStyled,
} from '»components/Menus/Mobile/Menu.mobile.styles';
import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';

export const DashboardMenuItemMobile = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );

  const { isAbleToProceed } = useIsAbleToProceed();
  const OPTION_ID = 'DASHBOARD';
  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      dispatch(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
      );
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
    });
  };

  return (
    <RootListItemButtonMobileStyled
      id="btnMenuDashboard"
      onClick={(event) => handleClickLeafMenu(event, OPTION_ID)}
      component={NavLink}
      to="/Dashboard"
      selected={activeMenuItem?.includes(OPTION_ID)}
      opened={activeNavigationMenuItem.includes(OPTION_ID)}
      isSubMenuPopup={activeNavigationMenuItem !== ''}
    >
      <ListItemIconMobileStyled>
        <FontAwesomeIconMobileStyled
          icon={faMobileButton}
          selected={activeMenuItem?.includes(OPTION_ID)}
        />
      </ListItemIconMobileStyled>
      <ListItemText primary={<FormattedMessage id="TRLT_UI-DASHBOARD" />} />
    </RootListItemButtonMobileStyled>
  );
};

DashboardMenuItemMobile.propTypes = {
  activeMenuItem: PropTypes.string,
  activeNavigationMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  setActiveNavigationMenuItem: PropTypes.func,
};
